import styled from "styled-components"

export const ButtonWrap = styled.div`
	display: flex;
	flex: 1;
	justify-content: space-between;
	flexdirection: row;
`
